import { render, staticRenderFns } from "./NewProduct.vue?vue&type=template&id=e0762b20&scoped=true"
import script from "./NewProduct.vue?vue&type=script&lang=ts"
export * from "./NewProduct.vue?vue&type=script&lang=ts"
import style0 from "./NewProduct.vue?vue&type=style&index=0&id=e0762b20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0762b20",
  null
  
)

export default component.exports